import { forwardRef } from 'react'

import { clsx } from 'clsx'

import { Badge, EyeIcon } from '@buffer-mono/popcorn'

import styles from './ViewOnlyBadge.module.css'

type ViewOnlyBadgeProps = Omit<
  React.ComponentPropsWithoutRef<typeof Badge>,
  'children' | 'size' | 'variant'
>

/**
 * The eye + "View only" badge that marks view-only channel access, shared by
 * Publish (page-header actions) and Community (header hint, expanded comment
 * cards) so the affordance reads identically everywhere. The view-only coach
 * marks anchor to the `data-testid`.
 */
export const ViewOnlyBadge = forwardRef<HTMLSpanElement, ViewOnlyBadgeProps>(
  ({ className, ...props }, ref) => (
    <Badge
      {...props}
      ref={ref}
      data-testid="view-only-badge"
      className={clsx(styles.badge, className)}
    >
      <EyeIcon />
      View only
    </Badge>
  ),
)

ViewOnlyBadge.displayName = 'ViewOnlyBadge'
